import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import formatPrice from '../../../../utilities/currency/formatPrice'
import renderHTML from 'react-render-html'
import ahcLoginRedirect from '../../../../utilities/profile/accor/ahcLoginRedirect'

import yn from 'yn'
import _ from 'lodash'

import tarsLoyaltyIcon from '../../../../assets/icons/tars-loyalty-icon.svg'

class BkFlowRoomCardRateStagePriceButtonCondensed extends Component {
	render() {
		const {
			activeStep,
			availabilityData,
			configData,
			currentQueryData,
			currentUpSells,
			displayedPriceFrequency,
			enhancementData,
			isLoyaltyRate,
			isMembersRate,
			isTaxInclusiveProperty,
			isProfileAuthenticated,
			multiRoomData,
			partnerRateData,
			rateBeforeDiscount,
			rateCancelDeadline,
			rateCurrencyCode,
			rateCurrencySymbol,
			// rateDestinationFeeAmount,
			// rateDestinationFeeCurrencyCode,
			// rateDestinationFeeCurrencySymbol,
			// rateDestinationFeeFrequency,
			// rateDestinationFeeLabel,
			rateDetailsExpanded,
			rateFeesTotal,
			ratePlanData,
			ratePlanName,
			rateTaxesFeesTotal,
			rateTaxesTotal,
			roomGroup,
			roomRateData,
			roomRateDetailsData,
			roomRatePrice,
			toggleActiveRoom,
			toggleRateDetails,
			upSellsToggleEvent,
			urlData,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		const totalNights = moment(urlData.endDate).diff(urlData.startDate, 'days')
		const totalFees = displayedPriceFrequency === 'per stay'
			? rateFeesTotal
			: rateFeesTotal / totalNights
		const totalTaxes = displayedPriceFrequency === 'per stay'
			? rateTaxesTotal - totalFees
			: rateTaxesFeesTotal / totalNights - totalFees

		return (
			<div className="bk-flow-room__price-content condensed">
				<div className="bk-flow-room__price-details">
					{isLoyaltyRate &&
						<div className="bk-flow-room__price-details-icon">
							<img src={tarsLoyaltyIcon} alt="Loyalty Member Rate"/>
							<p className="label u-remove-margin">{hotelLabels.yourRate ? hotelLabels.yourRate : 'Your Rate'}</p>
						</div>
					}

					{isMembersRate &&
						<p className="bk-flow-room__price-details-members-label u-remove-margin">
							{hotelLabels && hotelLabels.membersRate ? hotelLabels.membersRate : 'Members Rate'}
						</p>
					}

					<p
						className={rateTaxesTotal ?
							'bk-flow-room__price-details-rate u-remove-margin'
						:
							'bk-flow-room__price-details-rate'
						}
					>
						{ ratePlanData &&
							rateBeforeDiscount &&
							rateBeforeDiscount > 0 &&
							<span className="u-txt-strike">{rateCurrencySymbol}{formatPrice(rateBeforeDiscount)} {rateCurrencyCode}</span>
						}

						<span className="price">{rateCurrencySymbol}{formatPrice(roomRatePrice, 2, true)}&nbsp;</span>
						<span>
							{yn(process.env.REACT_APP_COMPONENT_ROOM_CURRENCY_CODES) && rateCurrencyCode && rateCurrencyCode}

							{yn(process.env.REACT_APP_COMPONENT_PRICE_AVG_LABELS) ?
								hotelLabels && hotelLabels.avg ? ' ' + hotelLabels.avg : ' Avg'
							:
								null
							}
							&nbsp;/&nbsp;
							{displayedPriceFrequency === 'per stay' ?
								hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'
							:
								hotelLabels && hotelLabels.night ? hotelLabels.night : 'Night'
							}
						</span>
					</p>

					{
						totalFees > 0 && isTaxInclusiveProperty &&
							<p className="bk-flow-room__price-details-taxes">
								({`Including ${rateCurrencySymbol}${formatPrice(totalFees, 2)} ${rateCurrencyCode} and ${rateCurrencyCode}${formatPrice(totalTaxes, 2)} ${rateCurrencyCode} ${_.get(hotelLabels, 'taxes', 'Taxes')} ${displayedPriceFrequency}.`})
							</p>
					}

					{
						totalFees > 0 && !isTaxInclusiveProperty &&
							<p className="bk-flow-room__price-details-taxes">
								{/* ({`Including ${rateCurrencySymbol}${formatPrice(totalFees, 2)} ${rateCurrencyCode} Fees ${displayedPriceFrequency}. ${_.get(hotelLabels, 'plus', 'Plus')} ${rateCurrencySymbol}${formatPrice(totalTaxes, 2)} ${rateCurrencyCode} ${_.get(hotelLabels, 'taxes', 'Taxes')} ${displayedPriceFrequency}.`}) */}
								({`Including ${rateCurrencySymbol}${formatPrice(totalFees, 2)} ${rateCurrencyCode} Fees ${displayedPriceFrequency}, excluding taxes.`})
							</p>
					}

					{ ratePlanName &&
						<p className="bk-flow-room__price-title u-remove-margin">
							{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_BRANDING) &&
								partnerRateData &&
								partnerRateData.logos &&
								partnerRateData.logos.dark &&
								<span
									className="bk-flow-room__price-title-partner-brand"
									onClick={() => toggleRateDetails()}
									tabIndex={0}
								>
									{
										_.includes(partnerRateData.logos.dark, '<svg')
											? renderHTML(partnerRateData.logos.dark)
											: <img alt="" src={partnerRateData.logos.dark} />
									}
								</span>
							}
							{ratePlanName}
						</p>
					}

					{ rateCancelDeadline &&
						<p className="cancel-deadline u-remove-margin">
							{hotelLabels && hotelLabels.cancelChargeMessage ? hotelLabels.cancelChargeMessage + ' ' : 'Cancel free of charge until '}{rateCancelDeadline}
						</p>
					}
				</div>

				<div className="bk-flow-room__price-buttons">
					<button
						onClick={() => toggleRateDetails()}
						className="bk-flow-room__price-details-button btn btn-text"
					>
						{ hotelLabels && hotelLabels.details ? hotelLabels.details : 'Details'}
						{ rateDetailsExpanded ? ' -' : ' +' }
					</button>

					{ !_.isEmpty(currentUpSells) ?
						<button
							className="btn btn-transparent"
							onClick={() => upSellsToggleEvent(roomRateData.roomTypeCode, roomRateData.ratePlanCode)}
						>
							{ hotelLabels && hotelLabels.selectRoom ? hotelLabels.selectRoom : 'Book Room '}
						</button>
						: isMembersRate &&
						!isProfileAuthenticated ?
						<button
							className="btn btn-transparent"
							onClick={() => ahcLoginRedirect(currentQueryData)}
						>
							{ hotelLabels && hotelLabels.claimRate ? hotelLabels.claimRate : 'Claim Rate'}
						</button>
					:
						<button
							className="bk-flow-room__price-button btn btn-primary"
							onClick={
								() => toggleActiveRoom(
									availabilityData,
									roomRateData.roomTypeCode,
									roomRateData.ratePlanCode,
									roomGroup,
									activeStep,
									multiRoomData,
									configData,
									urlData,
									enhancementData,
									roomRateDetailsData
								)
							}
						>
							{ hotelLabels && hotelLabels.selectRoom ? hotelLabels.selectRoom : 'Book Room' }
						</button>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeStep: state.activeStepData.activeStep,
		availabilityData: state.availabilityData.availability,
		configData: state.configData.configuration,
		currentQueryData: state.availabilityData.currentQuery,
		enhancementData: state.enhancementData,
		isProfileAuthenticated: state.profileData.isProfileAuthenticated,
		multiRoomData: state.multiRoomData,
		roomRateDetailsData: state.roomRateDetailsData,
		urlData: state.availabilityData.urlData,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomCardRateStagePriceButtonCondensed)


// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStagePriceButtonCondensed.js